<template>

    <div class="modal modalcentered fade" :id="id" tabindex="-1" role="modal-dialog" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <button
                            type="button"
                            class="close"
                            @click="actionHandler(0)"
                    >
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        <slot name="header">
                            título por defecto
                        </slot>
                    </h4>
                </div>

                <div class="modal-body">
                    <slot name="body">
                        This is the default body!
                    </slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">
                        <button type="button" class="btn btn-default btn-transparent" @click="actionHandler(0)" style="margin-right: 10px">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="actionHandler(1)">Aceptar</button>
                    </slot>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Modal',
        props: {
            id: {
                type: String,
                default: 'modal'
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            actionHandler(action) {
                this.$emit('modal:action', action);
            }
        },
        watch: {
            show () {
                $('#' + this.id).modal('toggle');
            }
        }
    }

</script>